import React from 'react';
import { ArrowRightIcon, SparklesIcon } from 'lucide-react';
const DashboardCard = ({
  title,
  description,
  imageUrl,
  category
}) => {
  return <div className="group relative bg-white rounded-2xl overflow-hidden transition-all duration-500 hover:scale-[1.02] border-2 border-gray-200 hover:border-indigo-300 shadow-lg hover:shadow-2xl" data-id="element-66">
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/5 via-purple-500/5 to-pink-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-67" />
      <div className="relative" data-id="element-68">
        <div className="relative overflow-hidden rounded-t-2xl" data-id="element-69">
          <img src={imageUrl} alt={title} className="w-full h-72 object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-70" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-71" />
          <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-2 group-hover:translate-y-0" data-id="element-72">
            <div className="bg-white/90 backdrop-blur-sm rounded-full p-3 shadow-lg" data-id="element-73">
              <ArrowRightIcon className="text-indigo-600" size={20} data-id="element-74" />
            </div>
          </div>
        </div>
        <div className="p-8" data-id="element-75">
          <div className="flex items-center gap-2 mb-4" data-id="element-76">
            <SparklesIcon className="text-indigo-600" size={16} data-id="element-77" />
            <span className="text-sm font-semibold text-indigo-600 tracking-wide uppercase" data-id="element-78">
              {category}
            </span>
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-indigo-600 transition-colors duration-300" data-id="element-79">
            {title}
          </h3>
          <p className="text-gray-700 leading-relaxed" data-id="element-80">{description}</p>
          <div className="mt-6 pt-6 border-t-2 border-gray-200" data-id="element-81">
            <div className="flex items-center text-indigo-600 font-medium group-hover:gap-2 transition-all duration-300" data-id="element-82">
              <span data-id="element-83">View Details</span>
              <ArrowRightIcon size={16} className="transform group-hover:translate-x-1 transition-transform duration-300" data-id="element-84" />
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export const DashboardsPreviewSection = () => {
  const dashboards = [{
    title: 'HR Management Dashboard',
    description: 'Comprehensive employee analytics, recruitment tracking, performance metrics, and workforce insights in real-time.',
    imageUrl: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    category: 'Human Resources'
  }, {
    title: 'Finance Dashboard',
    description: 'Track ARR, cash burn, runway, revenue share, profitability changes, and operating expenses with detailed insights.',
    imageUrl: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    category: 'Finance'
  }, {
    title: 'Vendor Management Overview',
    description: 'Monitor total vendors, active vendors, onboarding status, and analyze vendor distribution with quarterly growth trends.',
    imageUrl: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    category: 'Vendor Management'
  }, {
    title: 'Vendor Finance Overview',
    description: 'Manage outstanding payments, invoice approvals, scheduled payments, compliance alerts, and vendor spend analysis.',
    imageUrl: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    category: 'Vendor Finance'
  }, {
    title: 'Program Dashboard',
    description: 'Track active programs, resource allocation, program progress, and budget spend with detailed initiative cards.',
    imageUrl: 'https://images.unsplash.com/photo-1507925921958-8a62f3d1a50d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    category: 'Program Management'
  }];
  return <section className="w-full py-24 bg-white border-b border-gray-200" data-id="element-85">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86">
        <div className="text-center mb-20" data-id="element-87">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-50 border-2 border-indigo-200 rounded-full mb-6" data-id="element-88">
            <SparklesIcon className="text-indigo-600" size={18} data-id="element-89" />
            <span className="text-sm font-semibold text-indigo-600 tracking-wide uppercase" data-id="element-90">
              Dashboard Gallery
            </span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-6" data-id="element-91">
            Intelligent Dashboards for
            <span className="block mt-2 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent" data-id="element-92">
              Every Business Function
            </span>
          </h2>
          <p className="mt-6 text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed" data-id="element-93">
            Experience real-time insights with our AI-powered dashboards
            designed to transform data into actionable intelligence across all
            enterprise verticals.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-94">
          {dashboards.map((dashboard, index) => <DashboardCard key={index} title={dashboard.title} description={dashboard.description} imageUrl={dashboard.imageUrl} category={dashboard.category} data-id="element-95" />)}
        </div>
        <div className="mt-20 text-center" data-id="element-96">
          <div className="bg-gradient-to-r from-indigo-50 via-purple-50 to-pink-50 border-2 border-indigo-200 rounded-3xl p-12 shadow-lg" data-id="element-97">
            <h3 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-98">
              Ready to Transform Your Business Intelligence?
            </h3>
            <p className="text-lg text-gray-700 mb-8 max-w-2xl mx-auto" data-id="element-99">
              See these dashboards in action and discover how AI can
              revolutionize your decision-making process.
            </p>
            <button className="group bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-10 py-4 rounded-xl font-semibold hover:shadow-2xl hover:shadow-indigo-500/50 transition-all duration-300 transform hover:scale-105" data-id="element-100">
              <span className="flex items-center gap-2" data-id="element-101">
                Request a Live Demo
                <ArrowRightIcon size={20} className="transform group-hover:translate-x-1 transition-transform duration-300" data-id="element-102" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>;
};